import client from "./client";

const getUsers = () => client.get("users/all/paginated");

export default { getUsers };
